import { Create } from '../Vod/VodFactoryCreator';
import { VodBaseRenderModel } from '../Vod/VodBaseRenderModel';
import VodModuleTypeEnum from '@/enums/VodModuleTypeEnum';
import VodTypeEnum from '@/enums/VodTypeEnums';
import { t } from '@/main';
import { VodDetail } from '@/entities/VodDetail';
import VideoScheduleEnums from '@/enums/VideoScheduleEnums';

export class CustomCategoryRenderer implements Create {
  public GetValues(vodDetail: VodDetail, entityId: number, sessionStartDate: Date, uploadUrl: string, acceptedVideoFileTypes: string, acceptedCaptionFileTypes: string, subModuleType: number): VodBaseRenderModel {
    const CustomCategoryRendererBaseClass: VodBaseRenderModel = new VodBaseRenderModel();
    CustomCategoryRendererBaseClass.Moduletype = VodModuleTypeEnum[1].toString();
    CustomCategoryRendererBaseClass.SubModuleType = subModuleType;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions, no-unused-expressions
    CustomCategoryRendererBaseClass.SubModuleTypeValue = VodTypeEnum[subModuleType].toString(),
    CustomCategoryRendererBaseClass.ShowAddCaption = true;
    CustomCategoryRendererBaseClass.ShowPublish = true;
    const PublishItemList =  [{ Text : t('VirtualMeetings.AddVideo.PublishNow').toString() , Value : 1 },
      { Text : t('VirtualMeetings.AddVideo.CustomPublish').toString() , Value : 3 }];
    CustomCategoryRendererBaseClass.PublishItemList = PublishItemList;
    CustomCategoryRendererBaseClass.VodDetail = vodDetail;
    CustomCategoryRendererBaseClass.EntityId = entityId;
    CustomCategoryRendererBaseClass.UploadUrl = uploadUrl;
    CustomCategoryRendererBaseClass.AcceptedVideoFileTypes = acceptedVideoFileTypes;
    CustomCategoryRendererBaseClass.AcceptedCaptionFileTypes = acceptedCaptionFileTypes;
    CustomCategoryRendererBaseClass.PercentageVideoUploaded = 0;
    CustomCategoryRendererBaseClass.SessionStartDate = sessionStartDate;
    CustomCategoryRendererBaseClass.DefaultValue = VideoScheduleEnums.Now;
    CustomCategoryRendererBaseClass.Title = t('Information').toString();
    return CustomCategoryRendererBaseClass;
  }
}
